var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 22,
    viewBox: "0 0 31 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.73038 0.888393C2.42988 1.0695 0.690652 2.94132 0.579223 5.24732C0.486661 7.14746 0.399994 9.33371 0.399994 10.8433C0.399994 12.3529 0.488429 14.5893 0.582171 16.5042C0.69301 18.7807 2.39215 20.6402 4.66081 20.8496C7.17179 21.0814 10.8047 21.315 15.2571 21.315C19.7096 21.315 23.3236 21.0826 25.834 20.8513C28.1109 20.6413 29.8136 18.7701 29.9227 16.4847C30.0194 14.4684 30.1137 12.1612 30.1137 10.8427C30.1137 9.52426 30.0211 7.26663 29.9256 5.2662C29.8148 2.95076 28.0738 1.06773 25.7644 0.886623C23.293 0.693719 19.7278 0.503174 15.2565 0.503174C10.7853 0.503174 7.20185 0.694308 4.72979 0.888983L4.73038 0.888393ZM12.2863 6.43071L19.946 10.8433L12.2863 15.2559V6.43071Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.9cfab10e132881e5a5acd243fc58345b.svg";
export { ForwardRef as ReactComponent };